import styled from 'styled-components';

export const StyledWrapper = styled.div`

`;

export const StyledContent = styled.div<{
  contentWidth: number;
  wrapperWidth: number;
}>`
  width: ${({ contentWidth }) => contentWidth}px; 
  margin-left: -${({ contentWidth, wrapperWidth }) => (contentWidth - wrapperWidth) / 2}px; 
`;
